// extracted by mini-css-extract-plugin
export default {"select-store-type-step-options":"xUVdjt","selectStoreTypeStepOptions":"xUVdjt"};